/* eslint-disable no-console */
import React from 'react';

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        // 更新 state 使下一次渲染能够显示降级后的 UI
        return { hasError: true };
    }

    componentDidCatch(error: any, errorInfo: any): void {
        // 同样可以将错误日志上报给服务器
        console.log(error);
        console.log(errorInfo);
    }

    render() {
        const { hasError } = this.state;
        const { children } = this.props;
        if (hasError) {
            // 可以自定义降级后的 UI 并渲染
            return <h1>Something went wrong.</h1>;
        }
        return children;
    }
}

export default ErrorBoundary;

interface ErrorBoundaryProps {}
interface ErrorBoundaryState {
    hasError: boolean;
}
